import { lazy } from 'react'

import { authRoles } from '../../../auth/authRoles'
import { OperacionesProvider } from '../../base/contexts/OperacionesContext'

const KardexMovimientoApp = lazy(() => import('./view/KardexMovimiento'))
const KardexExistenciaApp = lazy(() => import('./view/KardexExistencia'))
const KardexPromedioPonderado = lazy(() => import('./view/KardexPromedioPonderado'))

export const kardexRoutesMap = {
  movimiento: {
    path: '/kardex/movimiento',
    name: 'Movimientos',
  },
  existencia: {
    path: '/kardex/existencia',
    name: 'Existencia',
  },
  promedioPonderado: {
    path: '/kardex/promedio-ponderado',
    name: 'Promedio Ponderado',
  },
}

/**
 * Estructura de ruta para cargar la página principal
 */
const kardexRoutes = [
  {
    path: kardexRoutesMap.movimiento.path,
    element: (
      <OperacionesProvider>
        <KardexMovimientoApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: kardexRoutesMap.existencia.path,
    element: (
      <OperacionesProvider>
        <KardexExistenciaApp />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
  {
    path: kardexRoutesMap.promedioPonderado.path,
    element: (
      <OperacionesProvider>
        <KardexPromedioPonderado />
      </OperacionesProvider>
    ),
    auth: authRoles.admin,
  },
]

export default kardexRoutes
